import { multiplyNumbersAsDecimals } from '@mews/framework/numeric';
import { type Amount, type MultiCurrencyAmount } from '@mews-distributor/common';

export const adjustCurrencyValueByPercentage = (
    currencyValue: MultiCurrencyAmount | null,
    adjustment: number
): MultiCurrencyAmount | null => {
    if (currencyValue == null) {
        return null;
    }

    return Object.entries(currencyValue).reduce<MultiCurrencyAmount>((accumulator, [currencyCode, amount]) => {
        const adjustedAmount: Amount = {
            ...amount,
            netValue: multiplyNumbersAsDecimals(amount.netValue, adjustment),
            grossValue: multiplyNumbersAsDecimals(amount.grossValue, adjustment),
            taxValues:
                amount.taxValues?.map((taxValue) => ({
                    ...taxValue,
                    value: multiplyNumbersAsDecimals(taxValue.value, adjustment),
                })) ?? [],
        };

        accumulator[currencyCode] = adjustedAmount;

        return accumulator;
    }, {});
};
